import React, { useEffect, useState } from "react";
import AuthService from "../../../../services/auth";
import { useGet } from "../../../../reducers/useGet";
import ReactLoading from "react-loading";

import ExportButton from "../../../data-table-custom/export-button";
import downloadCSV from "../../../../scripts/export-script";

import SelectDataButton from "../../date-selector";
import NoDataAvailableMessage from "../../messages-panel/no-data-available-message";
import ErrorMessage from "../../messages-panel/error-message";

import { nh3Sensor } from "../../../../sensors-type";

import { LineChart1Element } from "../../charts";
import moment from "moment";

import nh3Icon from "../../../../assets/icons/nh3-icon.png";
import { BiDotsHorizontal } from "react-icons/bi";

import "../panel-styles.css";

export default function AmmoniaGasDataPanel({ sensors }) {
	const { access_token } = AuthService.getCurrentUser();
	const [periodo1, setPeriodo1] = useState("");
	const [periodo2, setPeriodo2] = useState("");
	const [exportData, setExportData] = useState([]);
	const [nh3Array, setNH3Array] = useState([]);
	const [nh3LastData, setNH3LastData] = useState(null);
	let sensorData, api_request;

	// Procura pelo sensor de nivel de silo para
	// se fazer os requests dos dados medidos
	sensors.forEach((s) => {
		if (s.tipo === nh3Sensor) sensorData = s;
	});

	if (periodo1 === "") {
		let lastWeek = new Date();
		lastWeek.setDate(lastWeek.getDate() - 5);
		lastWeek = moment(lastWeek).format("YYYY-MM-DDT03:00");
		api_request = `evento_consulta?tipo_mensagem=1&sensor=${sensorData.id_dispositivo}&data:>=${lastWeek}`;
		setPeriodo1(new Date(moment(lastWeek).format("YYYY-MM-DDT00:00")));
	} else {
		let data1 = moment(periodo1).utc().format("YYYY-MM-DDTHH:mm");

		if (periodo2 !== "") {
			let data2 = moment(periodo2).utc().format("YYYY-MM-DDTHH:mm");
			api_request = `evento_consulta?tipo_mensagem=1&sensor=${sensorData.id_dispositivo}&data:>=${data1}&data:<=${data2}`;
		} else {
			api_request = `evento_consulta?tipo_mensagem=1&sensor=${sensorData.id_dispositivo}&data:>=${data1}`;
		}
	}

	let getData = useGet(api_request, access_token);
	let getLastData = useGet(
		`evento_consulta?tipo_mensagem=1&sensor=${sensorData.id_dispositivo}&ultimo_dado=1`,
		access_token
	);

	useEffect(() => {
		let dataArray = [];
		let exportDataAux = [];
		if (
			!getData.state.loading &&
			!getData.state.error &&
			getData.state.data.length > 0 &&
			!getLastData.state.loading &&
			!getLastData.state.error
		) {
			dataArray = getData.state.data.map((d) => {
				exportDataAux.push({
					id: d.id,
					data: moment
						.unix(d.timestamp / 1000)
						.format("DD/MM/YY HH:mm"),
					amonia: +d.valor_sensor,
				});

				return {
					timestamp: moment
						.unix(d.timestamp / 1000)
						.format("YYYY-MM-DDTHH:mm:ss"),
					value: +d.valor_sensor,
				};
			});

			dataArray = dataArray.sort(
				(d1, d2) =>
					new Date(d1.timestamp).getTime() -
					new Date(d2.timestamp).getTime()
			);

			exportDataAux = exportDataAux.map((objeto) => {
				const { id: propriedadeRemovida, ...restoDoObjeto } = objeto;
				return restoDoObjeto;
			});

			exportDataAux = exportDataAux.sort(
				(d1, d2) =>
					new Date(d1.data).getTime() - new Date(d2.data).getTime()
			);
		}

		setExportData(exportDataAux);
		setNH3LastData(getLastData.state.data[0]);
		setNH3Array(dataArray);
	}, [
		getData.state.loading,
		getData.state.error,
		getData.state.data,
		getLastData.state.loading,
		getLastData.state.error,
		getLastData.state.data,
	]);

	const Export = ({ onExport }) => (
		<ExportButton onExport={onExport} chartPanel={true} />
	);

	return (
		<div className="little-panel-container">
			<div className="panel-title-container">
				<em className="panel-title">
					Dados do Gás Amônia (NH<sub>3</sub>)
				</em>
			</div>
			<div>
				{getData.state.loading || getLastData.state.loading ? (
					<div className="panel-loading">
						<ReactLoading
							type="spinningBubbles"
							color="var(--main-color)"
							width="50px"
							height="50px"
						/>
					</div>
				) : getData.state.error || getLastData.state.error ? (
					<ErrorMessage />
				) : (
					<div style={{ margin: "10px" }}>
						<div className="panel-items">
							<BiDotsHorizontal />
							<span className="panel-items-title">
								Último Valor
							</span>
						</div>
						<div className="last-data-container">
							<div className="last-data-content-container">
								<img
									src={nh3Icon}
									height={"40px"}
									width={"40px"}
									alt=""
									style={{ marginRight: "5px" }}
								/>
								{nh3LastData !== undefined &&
								!isNaN(+nh3LastData.valor_sensor) ? (
									<p className="last-value-text">
										{+nh3LastData.valor_sensor} ppm
									</p>
								) : (
									<p className="last-value-text">-- ppm</p>
								)}
							</div>
							{nh3LastData !== undefined && nh3LastData.data ? (
								<span style={{ fontSize: "10px" }}>
									Dados atualizados em{" "}
									{moment(nh3LastData.data).format(
										"DD-MM-YY HH:mm"
									)}
								</span>
							) : (
								<span style={{ fontSize: "10px" }}>
									Dados atualizados em --
								</span>
							)}
						</div>

						<div className="panel-items">
							<BiDotsHorizontal />
							<span className="panel-items-title">
								Gráfico de Gás Amônia
							</span>
						</div>

						<SelectDataButton
							periodo1={periodo1}
							setPeriodo1={setPeriodo1}
							periodo2={periodo2}
							setPeriodo2={setPeriodo2}
							hourlyData={true}
						/>
						{nh3Array.length > 0 ? (
							<div className="chart-container">
								<LineChart1Element
									data={nh3Array}
									unit={"ppm"}
									color={"#475959"}
									fileName={"grafico-nh3"}
								/>
							</div>
						) : (
							<NoDataAvailableMessage />
						)}

						{nh3Array.length > 0 ? (
							<div className="panel-items">
								<BiDotsHorizontal />
								<span className="panel-items-title">
									Exportar dados do Gráfico
								</span>
								<div className="right-container">
									<Export
										onExport={() =>
											downloadCSV(
												exportData,
												`dados-amonia-NS${sensorData.serie}`
											)
										}
									/>
								</div>
							</div>
						) : null}
					</div>
				)}
			</div>
		</div>
	);
}
